import { SM } from '../assets/data/enum/storeModel.enum';
import { productionBase } from './base/production.base';

export const environment = {
  ...productionBase,
  themeConfig: {
    ...productionBase.themeConfig,
    brand: 'sdf',
    textName: 'SDF Farm Management',
    termsAndCondition: 'https://legal.xfarm.ag/#/terms-and-conditions?l=it&v=latest&b=sdf',
    privacyPolicy: 'https://legal.xfarm.ag/#/privacy-policy?l=it&v=latest&b=sdf',
    activeSocial: ['sdf'],
    enableForgotPassword: false,
    enableRegistration: false,
    enableLoginForm: false,
    enableSloganLogin: false,
    iOSAPPIDCode: '1534705490',
    downlaodAPPUrl:
      'https://s3-eu-west-1.amazonaws.com/cdn.xfarm.ag/install-app/sdf-farm-management-install.html',
    alarmViewMode: 'table',
    checkActiveAlarm: 'byDate',
    enableRedeemCouponPage: true,
    forceHideFunctionalityList: [
      SM.SM_ANALYTICS_SUSTAINABILITY,
      SM.SM_ANALYTICS_IMPACT,
      SM.SM_ANALYTICS_REGENERATIVE,
      SM.SM_ANALYTICS_OVERVIEW,
      SM.SM_ANALYTICS_CHAIN_MANAGEMENT,
      SM.SM_CONTRACT_MANAGEMENT,
      SM.SM_CONTRACT_AUDIT,
      SM.SM_GUIDE,
      SM.SM_EDUCATION_EDITOR,
      SM.SM_CROP_MAP,
      SM.SM_FARM_DOSSIER,
    ],
    showYaraNPK: false,
    alertPushSelectionEnable: false,
    newsSidebarTabActivation: false,
    advEnable: false,
  },
  apiBaseUrl: 'https://api-farm.sdfgroup.com/',
  SSOfrontAppCallback: 'https://farm.sdfgroup.com/#/oauthCheck?token=',
  assetsUrl: 'https://cdn.xfarm.ag/webapp/sdf/',
  launchDarklyKey: '67604a4534a7d409602cc4de',
  palette: {
    '--p-xfarm-50': '#fee7d2',
    '--p-xfarm-100': '#f9d0a6',
    '--p-xfarm-200': '#f1b97b',
    '--p-xfarm-300': '#e7a34f',
    '--p-xfarm-400': '#da8d1b',
    '--p-xfarm-500': '#c27e1b',
    '--p-xfarm-600': '#ab6f1b',
    '--p-xfarm-700': '#94611a',
    '--p-xfarm-800': '#7e5319',
    '--p-xfarm-900': '#694517',
    '--p-xfarm-950': '#543815',
  },
  primary: '#DA8D1B',
  primaryOpacity: '#DA8D1B',
  primaryOpacity15: '#DA8D1B26',
  secondary: '#878889',
  textLoginVersion: '#FFFFFF',
  btnSuccess: '#DA8D1B',
  backgroundSplashScreen: '#878889',
  navBarColor: '#878889',
  colorSidebarHeader: '#DA8D1B',
};
